import { ComponentColor } from "@common/types";
import {
    SUBSCRIPTION_STATUS_LABEL,
    SubscriptionStatus,
} from "@models/organization";

// Kept local to the customer Account feature rather than imported from
// Admin/Clients/_components/subscriptionStatus.ts — this codebase draws a
// hard line between @admin and @customer (no existing file crosses it), so a
// small duplicated status→label/color map beats coupling the two surfaces.
export const MEMBERSHIP_STATUS_META: Record<
    SubscriptionStatus,
    { label: string; color: ComponentColor }
> = {
    [SubscriptionStatus.None]: {
        label: SUBSCRIPTION_STATUS_LABEL[SubscriptionStatus.None],
        color: ComponentColor.Ghost,
    },
    [SubscriptionStatus.Active]: {
        label: SUBSCRIPTION_STATUS_LABEL[SubscriptionStatus.Active],
        color: ComponentColor.Success,
    },
    [SubscriptionStatus.Expired]: {
        label: SUBSCRIPTION_STATUS_LABEL[SubscriptionStatus.Expired],
        color: ComponentColor.Neutral,
    },
    [SubscriptionStatus.Cancelled]: {
        label: SUBSCRIPTION_STATUS_LABEL[SubscriptionStatus.Cancelled],
        color: ComponentColor.Error,
    },
    [SubscriptionStatus.Suspended]: {
        label: SUBSCRIPTION_STATUS_LABEL[SubscriptionStatus.Suspended],
        color: ComponentColor.Warning,
    },
};
